module.exports = __webpack_public_path__ + "img/Invite_Desktop.jpg";